export const PAYMENT_LIST_PAGE_SIZE = 10;

export enum PaymentStatus {
  Succeeded = 'succeeded',
  Failed = 'failed',
  Pending = 'pending',
  Refunded = 'refunded',
  Canceled = 'canceled',
  Paid = 'paid',
  Unpaid = 'unpaid',
}

export enum PaymentMethodType {
  Stripe = 'stripe',
  Card = 'card',
  Cash = 'cash',
  Cheque = 'cheque',
  PayPal = 'paypal',
  PaymentLink = 'payment_link',
}

export enum PaymentListOrderBy {
  PatientName = 'patient_name',
  Amount = 'amount',
  Status = 'status',
  PaymentDate = 'payment_date',
  InvoiceNumber = 'invoice_number',
  PaymentMethod = 'payment_method',
}

export enum PaymentListTableHeader {
  PatientName = 'Patient',
  InvoiceNumber = 'Invoice Number',
  Status = 'Status',
  Amount = 'Amount',
  PaymentMethod = 'Method',
  BillingDate = 'Billing Date',
}

export const headerOrderByMap: Record<
  PaymentListTableHeader,
  PaymentListOrderBy
> = {
  [PaymentListTableHeader.PatientName]: PaymentListOrderBy.PatientName,
  [PaymentListTableHeader.InvoiceNumber]: PaymentListOrderBy.InvoiceNumber,
  [PaymentListTableHeader.Status]: PaymentListOrderBy.Status,
  [PaymentListTableHeader.Amount]: PaymentListOrderBy.Amount,
  [PaymentListTableHeader.PaymentMethod]: PaymentListOrderBy.PaymentMethod,
  [PaymentListTableHeader.BillingDate]: PaymentListOrderBy.PaymentDate,
};

export const PAYMENT_LIST_STRINGS = {
  TITLE: 'Payment list',
  SEARCH_PLACEHOLDER: 'Search by patient name',
  FILTER_TITLE: 'Filter Payments',

  ALL_PAYMENTS: 'All Payments',
  UNPAID: 'Unpaid',
  PAID: 'Paid',

  DATE_RANGE: '05 - 11 May',

  DAY: 'Day',
  WEEK: 'Week',
  MONTH: 'Month',

  FILTER: 'Filter',

  AMOUNT_LABEL: 'Amount',
  ALL_AMOUNTS: 'All Amounts',
  AMOUNT_RANGE_1: '£0 - £100',
  AMOUNT_RANGE_2: '£100 - £500',
  AMOUNT_RANGE_3: '£500+',

  PAYMENT_METHOD_LABEL: 'Payment Method',
  ALL_METHODS: 'All Methods',
  CARD: 'Card',
  CASH: 'Cash',
  BANK_TRANSFER: 'Bank Transfer',

  RESET: 'Reset',
  APPLY: 'Apply',

  DISPLAYING: 'Displaying',
  OF: 'of',
  PAYMENTS: 'Payments',
};

export const FILTER_AMOUNT_OPTIONS = [
  {value: '', label: PAYMENT_LIST_STRINGS.ALL_AMOUNTS},
  {value: '0-100', label: PAYMENT_LIST_STRINGS.AMOUNT_RANGE_1},
  {value: '100-500', label: PAYMENT_LIST_STRINGS.AMOUNT_RANGE_2},
  {value: '500+', label: PAYMENT_LIST_STRINGS.AMOUNT_RANGE_3},
];

export const FILTER_PAYMENT_METHOD_OPTIONS = [
  {value: '', label: PAYMENT_LIST_STRINGS.ALL_METHODS},
  {value: 'stripe', label: 'Stripe'},
  {value: 'card', label: PAYMENT_LIST_STRINGS.CARD},
  {value: 'cash', label: PAYMENT_LIST_STRINGS.CASH},
  {value: 'cheque', label: 'Cheque'},
  {value: 'paypal', label: 'PayPal'},
  {value: 'bank', label: PAYMENT_LIST_STRINGS.BANK_TRANSFER},
];

export const VIEW_SWITCHER_OPTIONS = [
  {value: 'day', label: PAYMENT_LIST_STRINGS.DAY},
  {value: 'week', label: PAYMENT_LIST_STRINGS.WEEK},
  {value: 'month', label: PAYMENT_LIST_STRINGS.MONTH},
];
